import { SvgPropType } from './types/svgPropType';

const FacebookIcon = ({ width, height }: SvgPropType) => (
    <svg width={width || '32'} height={height || '31'} viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M31.5 15.5388C31.5 6.9614 24.556 0 16 0C7.444 0 0.5 6.9614 0.5 15.5388C0.5 23.0596 5.832 29.3218 12.9 30.7669V20.2005H9.8V15.5388H12.9V11.6541C12.9 8.65514 15.3335 6.21554 18.325 6.21554H22.2V10.8772H19.1C18.2475 10.8772 17.55 11.5764 17.55 12.4311V15.5388H22.2V20.2005H17.55V31C25.3775 30.2231 31.5 23.6035 31.5 15.5388Z" fill="black" />
    </svg>

);

export default FacebookIcon;
